import React, { useState, useRef, useCallback, useEffect } from 'react'
import { Row, Col, Form, Card } from '@deere/ux.uxframe-react'
import BusinessSegmentationPage from './BusinessSegmentationPage'
import LaborAbsenteeismPage from './LaborAbsenteeismPage'
import ButtonsSection from '../../components/ButtonsSection'
import FlexibilityPage from './FlexibilityPage'
import CapacityConstraints from './CapacityConstraintsPage'
import AdditionalCommentsPage from './AdditionalCommentsPage'
import OfpPage from './OfpPage';

import LeftMenu from '../../components/LeftMenu'
import { useSelector } from 'react-redux'
import CustomAlert from '../../components/CustomAlert'
import { isSupplierAllowed, getDateFromTimeStamp, getTranslation } from '../../utils/utils'
import { useHistory, useLocation } from 'react-router'
import { EMPTY_BODY, SCBM_CODE, DATE_FORMAT, ERROR_SAVING_SURVEY, SCBM_SECCIO_CODES } from '../../utils/surveyLiterals'
import store from '../../redux/store'
import { useDispatch } from 'react-redux'
import { getSectionsWithErrors, validationOnCheckboxes } from '../../utils/validation'
import { useTranslation } from "react-i18next";
import { savedSuccessFullySurvey } from '../../redux/action/saveAction'
import {handleSaveOrUpdate,deleteAnswers} from '../../utils/saveSurveyUtils'
import { useOktaAuth } from '@okta/okta-react';  
import CyberSecurityPage from './CyberSecurityPage'
import OtherPage from './OtherPage'


export default function ScbmSurveyPage({ survey, setSurvey , countryList, surveyLanguages}) {
    const pages = ['Business Segmentation', 'Labor / Absenteeism', 'Order Fulfillment', 'Capacity / Constraints', 'Flexibility', 'Tier II Suppliers', 'Additional Comments', 'Cyber Security', 'Other'];
    let sectionsTitles = [...pages]
    const { authState } = useOktaAuth();
    const surveyResponse = useSelector(state => state.survey.surveyResponse)
    const userInfo = useSelector(state => state.survey.userInfo)
    const [actLink, setActLink] = useState(new Array(sectionsTitles.length).fill(""));
    const [validated, setValidated] = useState(false)
    const [errors, setErrors] = useState([])
    const totalBs = useSelector(state => state.survey.total)
    const sectionsRef = useRef([new Array(sectionsTitles.length)]);
    const surveySaved = useSelector((state) => state.save.saveSurvey)
    const location = useLocation()
    const history = useHistory()
    const dispatch = useDispatch()
    const { t } = useTranslation();
    const campaign = store.getState().campaign.campaignAssigned;
    const [title] = useState({
        updatedByName: location && location.state ? location.state.updatedByName : campaign.updatedByName,
        supplierName: location && location.state ? location.state.supplierName : campaign.assignments[0].supplierName,
        surveyType: location && location.state ? location.state.surveyType : survey.description,
        updatedTs: location && location.state ? location.state.updatedTs : campaign.assignments[0].updatedTs
    })  

    const handleScroll = useCallback(() => {
        const currentScrollPos = window.pageYOffset;
        let tmpActLink = new Array(sectionsTitles.length).fill("");
        let tmpRefs = []
        sectionsRef.current.map((section) =>
            ((currentScrollPos + 300) >= (section.offsetTop)) ? tmpRefs.push('active') : tmpRefs.push('')
        )
        tmpActLink[tmpRefs.lastIndexOf('active')] = 'active'
        setActLink(tmpActLink)
    }, [sectionsTitles.length, location.state]);

    const surveyTitle = () => { 
        if (title) {
            if (!title.updatedByName) {
                return (<div className='p-2'>
                    <h1>{title.surveyType}</h1>
                    <h5>{title.supplierName}</h5>
                    <h5>Due date {getDateFromTimeStamp(new Date(campaign.endDate))}</h5>
                </div>)
            }
            else {
                return (<div className='p-2'>
                    <h1>{title.surveyType}</h1>
                    <h5>{title.supplierName} </h5>
                    <h5>Due date {getDateFromTimeStamp(new Date(campaign.endDate))}</h5>
                    <h5>{` Last saved on ${title.updatedTs} by ${title.updatedByName}`}</h5>
                </div>)
            }
        }
        return null
    }

    useEffect(() => {
        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    if (!survey) {
        return EMPTY_BODY;
    }

    const handleSubmit = async(event) => {
        clearErrors();
        const form = event.currentTarget;
        let errorSections = getSectionsWithErrors(form);
        
        if (totalBs !== 100) {
            const bsAlert = document.querySelectorAll('[id=bsTotal]')
            const bsSection = bsAlert && bsAlert.length > 0 ? bsAlert[0].getAttribute('name') : ''
            if(bsSection && errorSections.findIndex(err => err  === bsSection) < 0)
                errorSections.push(bsSection);            
        }
        
        const checkboxes = document.querySelectorAll('input[type=checkbox]');
        validationOnCheckboxes(checkboxes, errorSections);
        setErrors(errorSections);

        if (errors && errors.length > 0) {
            event.preventDefault();
            event.stopPropagation();
        }
        
        setValidated(true);
        event.preventDefault();
        event.stopPropagation();
        const surveyAnswersTmp = [...store.getState().survey.surveyAnswers];
        deleteAnswers(surveyAnswersTmp,survey);
        if (form.checkValidity() && errorSections.length <= 0) {
            setValidated(false);
            dispatch(savedSuccessFullySurvey({ variant: undefined, description: undefined }));
            const saveResponse = await handleSaveOrUpdate(surveyResponse, surveyAnswersTmp, campaign, userInfo, authState, dispatch, t('lbl_success_save_message'));
            if(saveResponse && saveResponse.id){
                const updByName = location && location.state ? location.state.updatedByName : campaign.updatedByName;
                const supplierName = location && location.state ? location.state.supplierName : campaign.assignments[0].supplierName;
                const surveyType = location && location.state ? location.state.surveyType : survey.description;
                history.push({
                    pathname: '/review',
                    state: {
                        previous: '/scbm',
                        survey: survey,
                        updatedByName: updByName,
                        supplierName: supplierName,
                        surveyType: surveyType,
                        campaign:campaign,
                        updatedTs: location && location.state ? location.state.updatedTs : ""
                    }
                })
            }else{
                setErrors([ERROR_SAVING_SURVEY]);
            }
        }
        window.scrollTo(0, 0);
    }

    const showErrorCard = <>
        <Card className='p-2 mb-2 bg-danger'>
            <Card.Body className="uxf-card-body-table">
                <Card.Title className='pb-3 text-white'>
                    {t('lbl_error_survey_validation')}
                </Card.Title>
                {
                    errors.map((error, index) =>
                        <div key={index}>
                            <li className='text-white'>{error}</li>
                        </div>
                    )
                }
            </Card.Body>
        </Card>
        <br />
    </>

    function clearErrors(){
        setValidated(false);
        setErrors([]);
    }

    const noteSection = survey.sections.find((e) => e.code === SCBM_SECCIO_CODES.NOTE && e.active);
    const notes = [];
    if(noteSection){
        noteSection.questions.forEach((que) => {
            if(que.type === 'OPEN_TITLE'){
                notes.push(que);
            }
        })
    }

    return (<div>
        <Row>
            {surveyTitle()}
        </Row>
        <Row>
            <Col xs={24} md={5}>
                {actLink.length > 0 && <LeftMenu actLink={actLink} survey={survey} />}
            </Col>
            <Col xs={24} md={19}>
                {
                    errors.length > 0 ? showErrorCard : null
                }
                {
                    surveySaved.variant === 'success' ?
                        <CustomAlert accessibilityLabel={surveySaved.variant} variant={surveySaved.variant} title={surveySaved.description} />
                        : null
                }                
                <Form noValidate validated={validated} onSubmit={handleSubmit}>
                    <div ref={el => sectionsRef.current[0] = el}>
                        <BusinessSegmentationPage survey={survey} />
                    </div>
                    <br />
                    <div ref={el => sectionsRef.current[1] = el}>
                        <LaborAbsenteeismPage survey={survey} countryList={countryList} />
                    </div>
                    <br />
                    {
                        survey.sections.find(e => e.code === SCBM_SECCIO_CODES.OF && e.active) ?
                        <>
                            <div ref={el => sectionsRef.current[2] = el}>
                                <OfpPage survey={survey} />
                            </div>
                            <br />
                        </>
                        : <></>
                    }
                    <div ref={el => sectionsRef.current[3] = el}>
                        <CapacityConstraints survey={survey} />
                    </div>
                    <br />
                    <div ref={el => sectionsRef.current[4] = el}>
                        <FlexibilityPage survey={survey} />
                    </div>
                    <br />
                    {/* <div ref={el => sectionsRef.current[5] = el}>
                        <TierPage survey={survey} country={country} updatedByName={!location.state ? '' : location.state.updatedByName} supplierName={!location.state ? '' : location.state.supplierName} />
                    </div>
                    <br /> */}
                    {
                        survey.sections.find((e) => e.code === SCBM_SECCIO_CODES.AC && e.active) ? 
                        <>
                            <div ref={el => sectionsRef.current[6] = el}>
                                <AdditionalCommentsPage survey={survey} />
                            </div>
                            <br />
                        </> 
                        : 
                        null
                    }
                    {
                        survey.sections.find((e) => e.code === SCBM_SECCIO_CODES.CS && e.active) ? 
                        <>
                            <div ref={el => sectionsRef.current[7] = el}>
                                <CyberSecurityPage survey={survey}/>
                            </div>
                            <br />
                        </> 
                        : 
                        null
                    }
                    {
                        survey.sections.find((e) => e.code === SCBM_SECCIO_CODES.OTH && e.active) ? 
                        <>
                            <div ref={el => sectionsRef.current[8] = el}>
                                <OtherPage survey={survey}/>
                            </div>
                            <br />
                        </> 
                        : 
                        null
                    }
                    {
                        noteSection && notes.length > 0 ? (
                            <>{notes.map((note) => {
                                return <div align="justify" ref={(el) => (sectionsRef.current[9] = el)}>
                                    <h5>{getTranslation(note, "text")}</h5>
                                </div>
                            })}<br/></>
                        ) : (
                            <><div align="justify" ref={(el) => (sectionsRef.current[9] = el)}>
                                <h5>{t("button_survey_legen")}</h5>
                            </div><br/></>
                        )
                        
                    }
                    {userInfo && isSupplierAllowed(userInfo.userType) &&
                        <ButtonsSection
                            setSurvey={setSurvey}
                            campaign={campaign} 
                            clearFunction={clearErrors}
                            survey={survey}
                            surveyLanguages={surveyLanguages}
                        />
                    }
                </Form>
            </Col>
        </Row >
    </div>
    )
}
